// 当クラスはFilter.jsとCatalouge.jsに使用（extends）されてる為、
// 改修の場合は、その改修がそれらの機能に影響がないか、ご確認ください。
class Modal {
    constructor({
        modalId, 
        modalOpener, 
        modalCloser,
    }) {
        this.modal = document.getElementById(modalId);
        this.modalOpeners = document.querySelectorAll(`.${modalOpener}`);
        this.modalCloser = document.getElementById(modalCloser);
        this.body = document.querySelector('body');
        this.bodyOverlay = document.getElementById('bodyOverlay');
        this.navMenu = document.getElementById('navMenu');

        // 処理用の初期データ
        this.modalIsOpen = false;
        this.windowPosition;

        // 必須の要素がある場合のみに、ブラウザやDOMのイベントを監視する
        if(this.modalOpeners && this.modal) {
            this.event();
        }

    }

    // ============
    // Events
    // =============
    event() {
        this.modalOpeners.forEach(modalOpener => modalOpener.addEventListener('click', this.openModal.bind(this)));
        this.modalCloser.addEventListener('click', this.handleModalClose.bind(this));
        document.addEventListener('keyup', event => this.handleKeyboardPress(event));
        window.addEventListener('load', this.checkModal.bind(this));
    }

    // ============
    // Methods
    // =============

    // モーダルのクラスを監視し、「is-visible」のクラス
    checkModal() {
        if(this.modal.classList.contains('is-visible')) {
            this.openModal();
        }
    }

    // モーダルを開く
    openModal() {
        this.bodyOverlay.classList.add('is-visible');
        this.modal.showModal();
        this.modal.classList.add('is-visible');
        this.modalIsOpen = true;
        this.handleBodyfixing();
    }

    // モーダルを閉じる
    handleModalClose() {
        this.modal.close();
        this.modal.classList.remove('is-visible');
        this.bodyOverlay.classList.remove('is-visible');
        this.modalIsOpen = false;
        this.handleBodyfixing();
    }

    // bodyのスクロールを固定する
    handleBodyfixing() {
        if(this.modalIsOpen) {
            this.windowPosition = window.scrollY;
            this.body.classList.add('is-fixed');
            this.body.style.top = `-${this.windowPosition}px`
        }else {
            this.body.classList.remove('is-fixed');
            this.body.style.top = "";
            window.scrollTo({left: 0, top: this.windowPosition, behavior:'instant'});
        }
    }

    // キーボード操作の処理
    handleKeyboardPress(event) {
        if(!this.navMenu.classList.contains('is-visible')) {
            if(event.keyCode && event.keyCode === 27) {
                this.handleModalClose();
            }
        }
    }

}

export default Modal;